export interface ReleaseLoginBody {
  applicationId: string;
}
